import { BaseEntity } from '../../../models';
import { ItemMarca } from '../../item-marca';

export class UsuarioMarca implements BaseEntity {
    readonly id: number;
    idUsuario: number;
    idItemMarca: number;
    itemMarca: ItemMarca;
}
